import { useEffect, useState } from "react";
import { FileText, Briefcase, Newspaper, MessagesSquare, TrendingUp } from "lucide-react";

import AdminLayout from "@/pages/admin/AdminLayout";
import { adminStats } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    adminStats().then(setStats).catch(console.error);
  }, []);

  const tiles = stats
    ? [
        { label: "Totaal analyses", value: stats.total_checks, Icon: FileText, color: "#002FA7" },
        { label: "Voltooid", value: stats.completed_checks, Icon: TrendingUp, color: "#10B981" },
        { label: "B2B partners", value: stats.businesses, Icon: Briefcase, color: "#264653" },
        { label: "Pending aanmeldingen", value: stats.pending_businesses, Icon: Briefcase, color: "#F59E0B" },
        { label: "Blog posts", value: stats.blog_posts, Icon: Newspaper, color: "#00B4D8" },
        { label: "Onbehandelde contact-msgs", value: stats.unhandled_contact_messages, Icon: MessagesSquare, color: "#F4A261" },
      ]
    : [];

  return (
    <AdminLayout>
      <div data-testid="admin-dashboard">
        <h1 className="font-display text-3xl font-bold text-ink tracking-tight">Dashboard</h1>
        <p className="text-ink-soft mt-1 text-sm">Een overzicht van CheckExpert in real-time.</p>

        {!stats ? (
          <div className="mt-10 text-ink-soft">Statistieken laden…</div>
        ) : (
          <>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
              {tiles.map((t) => (
                <div key={t.label} className="rounded-2xl bg-white border border-border p-6">
                  <div className="flex items-start justify-between">
                    <div className="text-xs uppercase tracking-wider text-ink-soft font-semibold">{t.label}</div>
                    <span
                      className="h-9 w-9 rounded-xl flex items-center justify-center text-white"
                      style={{ background: t.color }}
                    >
                      <t.Icon className="h-4 w-4" />
                    </span>
                  </div>
                  <div className="font-display text-4xl font-bold text-ink mt-4">{t.value ?? 0}</div>
                </div>
              ))}
            </div>

            <div className="mt-10 rounded-2xl bg-white border border-border p-6">
              <h2 className="font-display text-lg font-bold text-ink">Top 5 checkers</h2>
              <div className="mt-4 space-y-2">
                {(stats.top_checkers || []).map((c) => (
                  <div key={c.slug} className="flex items-center justify-between p-3 rounded-lg bg-secondary">
                    <span className="font-medium text-ink">{c.slug}</span>
                    <span className="text-sm text-ink-soft">{c.count} analyses</span>
                  </div>
                ))}
                {(!stats.top_checkers || stats.top_checkers.length === 0) && (
                  <p className="text-sm text-ink-soft">Nog geen analyses uitgevoerd.</p>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </AdminLayout>
  );
}
